import { render, staticRenderFns } from "./IdoneitaUrine.vue?vue&type=template&id=7f1a0af2"
import script from "./IdoneitaUrine.vue?vue&type=script&lang=js"
export * from "./IdoneitaUrine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports